import React from 'react';
import { motion } from 'framer-motion';
import SearchBox from '../components/SearchBox';
import AcademicSourcesCarousel from '../components/AcademicSourcesCarousel';
import Logo from '../components/Logo';

const HomePage = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  const features = [
    {
      title: "Búsqueda auténtica",
      description: "Resultados reales de fuentes académicas verificadas con URLs funcionales"
    },
    {
      title: "Fuentes múltiples",
      description: "Acceso directo a más de 40 bases de datos académicas y científicas"
    },
    {
      title: "Resultados exactos",
      description: "Búsquedas precisas con filtros avanzados por año, idioma y tipo de documento"
    },
    {
      title: "Enlaces funcionales",
      description: "Todos los enlaces conducen a documentos reales y accesibles"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50 dark:from-gray-900 dark:via-gray-800 dark:to-purple-900">
      <div className="container mx-auto px-4 py-20">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          className="text-center space-y-12"
        >
          {/* Hero Section */}
          <motion.div variants={itemVariants} className="space-y-6">
            <div className="flex justify-center">
              <Logo size={120} />
            </div>
            <h1 className="text-5xl md:text-7xl font-bold bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 bg-clip-text text-transparent">
              MentIAx
            </h1>
            <p className="text-xl md:text-2xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
              Tu enlace con el conocimiento global. Explora fuentes académicas auténticas con resultados reales y enlaces funcionales.
            </p>
          </motion.div>

          {/* Search Box */}
          <motion.div variants={itemVariants}>
            <SearchBox />
          </motion.div>

          {/* Academic Sources Carousel */}
          <motion.div variants={itemVariants}>
            <AcademicSourcesCarousel />
          </motion.div>

          {/* Features Grid */}
          <motion.div variants={itemVariants} className="mt-20">
            <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-12">
              Características principales
            </h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
              {features.map((feature, index) => (
                <motion.div
                  key={index}
                  className="bg-white dark:bg-gray-800 p-6 rounded-2xl shadow-lg border border-gray-200 dark:border-gray-700"
                  whileHover={{ scale: 1.05, y: -5 }}
                  transition={{ duration: 0.3 }}
                >
                  <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600 dark:text-gray-300">
                    {feature.description}
                  </p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default HomePage;